<template>
  <div class="container changePassword">
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb class="elBreadcrumb" separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item class="elBreadcrumbFirstItem">当前位置：设置</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item class="elBreadcrumbLastItem">修改密码</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->

    <div class="content">
      <div class="toDoListDiv">
        <h3 class="title">修改密码</h3>
        <div class="toDoList">
          <div class="toDoListItem">
            <span>当前密码：</span>
            <el-input v-model="nowPassword" placeholder="请输入当前密码"></el-input>
          </div>
          <div class="toDoListItem">
            <span>新密码：</span>
            <el-input v-model="newPassword" placeholder="请输入新密码"></el-input>
            <span class="warningText">6-16个字符</span>
          </div>
          <div class="toDoListItem">
            <span>确认密码：</span>
            <el-input v-model="resetNewPassword" placeholder="请输入确认密码"></el-input>
          </div>
        </div>
        <div class="optionBtnDiv">
          <el-button type="primary" :loading="loading" class="editBtn" @click="sureEditClick">确认修改</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';
export default {
  inject: ['$http', '$api', '$utils','$userUtils'],
  name: "memberShipList",
  data() {
    return {
      userInfo: {},  //用户信息
      nowPassword: "",  //当前密码
      newPassword: "",  //新密码
      resetNewPassword: "",  //确认密码
      loading: false
    }
  },
  mounted() {
    //获取当前用户信息
    this.getUserInfo();
  },
  methods: {
    /**
     * 获取当前登陆者个人信息
     */
    getUserInfo() {
      let that = this;
      that.$http.post(that.$api.getUserInfoApi).then(res => {
        if(res.data) {
          that.userInfo = res.data;
        }
      })
    },
    /**
     * 确认修改按钮点击事件
     */
    sureEditClick() {
      let that = this;
      //判断是否输入了密码
      if(that.$utils.isEmpty(that.nowPassword)) {
        that.$message.warning("请输入当前密码");
        return
      }

      //判断是否输入了新密码
      if(that.$utils.isEmpty(that.newPassword)) {
        that.$message.warning("请输入新密码");
        return
      }

      if(that.newPassword.length < 6 || that.newPassword.length > 16) {
        that.$message.warning("新密码请输入6-16位字符");
        return
      }

      //判断是否输入了确认密码
      if(that.$utils.isEmpty(that.resetNewPassword)) {
        that.$message.warning("请输入确认密码");
        return
      }

      if(that.resetNewPassword != that.newPassword) {
        that.$message.warning("新密码与确认密码输入不一致");
        return
      }

      that.loading = true;
      that.$http.post(that.$api.editUserPwdApi, {
        "userId": that.userInfo.id,
        "pwd": md5(that.newPassword),
        "oldPwd": md5(that.nowPassword)
      }).then(res => {
        that.loading = false;
        if(res.code == 200) {
          console.log(res)
          that.$message.success("密码修改成功，请重新登录");

          //密码修改成功，跳转至登录页重新登陆
          this.$userUtils.clearUserToken()
          this.$router.push('/login')
        }else{
          that.loading = false;
        }
      }).catch(err => {
        that.loading = false;
      })
    }
  },
}
</script>

<style>
	.changePassword .el-input__wrapper{
		box-shadow: 0 0 0 1px #dcdfe6 inset !important;
	}
</style>
<style scoped>
.content {
  background-color: #fff;
  margin-bottom: 12px;
  padding-bottom: 20px;
}

.title {
  font-size: 14px;
  border-bottom: 1px solid #f6f6f6;
  color: #333;
  font-weight: normal;
  padding: 0 15px;
  box-sizing: border-box;
  line-height: 42px;
}

.toDoListItem {
  width: 100%;
  min-height: 40px;
  margin-top: 12px;
  overflow: auto;
  padding: 0 15px;
}

.toDoListItem span {
  width: 90px;
  display: inline-block;
  float: left;
  color: #666;
  font-size: 13px;
  line-height: 40px;
  text-align: right;
}

.toDoListItem span.warningText{
  color: #f00;
}

.toDoListItem .el-input {
  width: 500px;
  float: left;
}

.optionBtnDiv {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>